@if (configToEdit) {
    @switch (configToEdit.widgetType) {
        @case (tailoredWidgetType.BUSINESS_INTELLIGENCE_WIDGET) {
            <business-intelligence-widget-config-editor
                [configToEdit]="configToEdit"
                [acceptedDashboardModes]="acceptedDashboardModes"
                [dashboardScopeType]="dashboardScopeType"
                [isEditing]="isEditing"
                (configChanged)="childConfigChanged($event)"
            />
        }
        @case (tailoredWidgetType.TEMPLATE_WIDGET) {
            <template-widget-editor [configToEdit]="configToEdit" (configChanged)="childConfigChanged($event)" />
        }
    }
}
